import React, { createContext, FC, useState } from 'react';

export interface ISideNavContext {
  showNav: boolean;
  setShowNav: (val: boolean) => void;
}

export const SideNavContext = createContext<ISideNavContext>({
  showNav: localStorage.getItem('stonemartin-nav-open') === 'false' ? false : true,
  setShowNav: () => {}
});

interface ISideNavContextHandlerProps {}

export const SideNavHandler: FC<ISideNavContextHandlerProps> = ({ children }): JSX.Element => {
  const [showNav, setShowNav] = useState(localStorage.getItem('stonemartin-nav-open') === 'false' ? false : true);
  return <SideNavContext.Provider value={{ showNav, setShowNav }}>{children}</SideNavContext.Provider>;
};
